import type { DeepPartial } from '@luna/utils-ts';

import type { Trading } from '../../types';

export const tradingConfigHU: DeepPartial<Trading> = {};
